module.exports = __webpack_public_path__ + "img/avatar-boy.7a829c2e.png";